var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 289.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ef6f38;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M333.76,133.47V52.31h29l16.51,33.52,16.38-33.52h29v81.16h-30.5V105l-7.18,14.62h-15.5L364.25,105v28.48Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M459,133.47V104L429.66,52.31h31.75l12.86,25.84,12.85-25.84h31.76L489.52,104v29.49Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M552.9,133.47V52.31h64.9V74.24H583.4v7.31H613v22.68H583.4v29.24Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M614,133.47l31.26-81.16h31.63l31.25,81.16H676.4l-5.8-15.12h-19l-5.8,15.12Zm40.83-35.92H667.2L661,82.05Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M716.35,133.47V52.31h29l16.51,33.52,16.39-33.52h29v81.16h-30.5V105l-7.18,14.62H754L746.85,105v28.48Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M817.92,133.47V52.31h30.5v81.16Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M859.13,133.47V52.31h30.5v58h33.14v23.19Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M935.75,133.47V104L906.39,52.31h31.75L951,78.15l12.85-25.84h31.76L966.25,104v29.49Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M333.76,245.37V164.21h64.9v21.93H364.25v7.31h29.62v22.68H364.25v29.24Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M434.32,245.37V164.21h30.5v81.16Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M521.15,245.37V186.14H500.48V164.21h71.83v21.93H551.64v59.23Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M608,245.37V164.21h25.59L656.24,196V164.21h30.5v81.16H661l-22.56-31.76v31.76Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M726.81,245.37V164.21h64.9v21.93h-34.4v7.31h29.61v22.68H757.31v7.31h34.4v21.93Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M856.11,246.63a91.37,91.37,0,0,1-16.51-1.45A48.2,48.2,0,0,1,826.24,241V218.15a69.19,69.19,0,0,0,13.36,4.79,54.33,54.33,0,0,0,13.23,1.89,15,15,0,0,0,5.92-1c1.43-.63,2.14-1.53,2.14-2.71,0-1.51-1.34-2.68-4-3.53s-6.22-2-10.58-3.65a55.52,55.52,0,0,1-12.35-6.3,18.61,18.61,0,0,1-6.49-7.88,29.45,29.45,0,0,1-2-11.53q0-25.32,35.67-25.33a80,80,0,0,1,9,.57q5,.57,9.7,1.45a74.38,74.38,0,0,1,8,1.89v22.93a62.85,62.85,0,0,0-12.22-3.9,50.83,50.83,0,0,0-9.33-1,37.34,37.34,0,0,0-6.42.57c-2.19.38-3.28,1.24-3.28,2.58,0,1.09,1,1.95,2.9,2.58s5,1.54,9.2,2.71q10.08,2.77,15.12,6.62a18.61,18.61,0,0,1,6.74,9.07,38.76,38.76,0,0,1,1.7,12,22.31,22.31,0,0,1-9.07,18.59Q874.13,246.63,856.11,246.63Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M957.93,246.63a91.45,91.45,0,0,1-16.51-1.45A48.31,48.31,0,0,1,928.06,241V218.15a69.19,69.19,0,0,0,13.36,4.79,54.46,54.46,0,0,0,13.23,1.89,15.06,15.06,0,0,0,5.93-1c1.42-.63,2.14-1.53,2.14-2.71,0-1.51-1.35-2.68-4-3.53s-6.22-2-10.59-3.65a55.75,55.75,0,0,1-12.35-6.3,18.69,18.69,0,0,1-6.49-7.88,29.64,29.64,0,0,1-2-11.53Q927.31,163,963,163a79.86,79.86,0,0,1,9,.57c3.32.38,6.55.86,9.71,1.45a75,75,0,0,1,8,1.89v22.93a62.92,62.92,0,0,0-12.23-3.9,50.73,50.73,0,0,0-9.32-1,37.46,37.46,0,0,0-6.43.57c-2.18.38-3.28,1.24-3.28,2.58,0,1.09,1,1.95,2.9,2.58s5,1.54,9.2,2.71q10.08,2.77,15.13,6.62A18.74,18.74,0,0,1,992.4,209a39.06,39.06,0,0,1,1.7,12A22.32,22.32,0,0,1,985,239.64Q976,246.63,957.93,246.63Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175,158.88h0l89.59,10.58V104.71l-93.44,11.4C192.13,88,210.11,63.82,229.3,38,209.6,26.86,191.65,16.67,172,5.5L134.35,95.66C121,63.06,109.6,35.09,97.31,5L40.11,38.46l58.53,77.95-94.25-12v65.17l93.73-11.19S137.74,154.48,175,158.88Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216.1,191.59a92,92,0,0,1-162.79,0H6.41a135.24,135.24,0,0,0,256.59,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.377a5e3a963ae6068f2872ed05d4da06.svg";
export { ForwardRef as ReactComponent };